import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';

import { FieldConfig } from '../../models/field-config.interface';

@Component({
  exportAs: 'dynamicForm',
  selector: 'dynamic-form',
  styleUrls: ['dynamic-form.component.scss'],
  template: `
    <form
      class="dynamic-form"
      [formGroup]="form"
      (submit)="handleSubmit($event)">
      <ng-container
        *ngFor="let field of config;"
        dynamicField
        [config]="field"
        [options]="options"
        [group]="form">
      </ng-container>
    </form>
  `
})
export class DynamicFormComponent implements OnChanges, OnInit {
  @Input()
  config: FieldConfig[] = [];

  @Input()
  options: any = {};

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  form: FormGroup;

  get controls() { return this.config.filter(({ type }) => type !== 'button'); }
  get changes() { return this.form.valueChanges; }
  get valid() { return this.form.valid; }
  get value() { return this.form.value; }
  get pristine() { return this.form.pristine; }
  get untouched() { return this.form.untouched; }

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.form = this.createGroup();
  }

  ngOnChanges() {
    if (this.form) {
      const controls = Object.keys(this.form.controls);
      const configControls = this.controls.map((item) => item.name);

      controls
        .filter((control) => !configControls.includes(control))
        .forEach((control) => this.form.removeControl(control));

      configControls
        .filter((control) => !controls.includes(control))
        .forEach((name) => {
          const config = this.config.find((control) => control.name === name);
          this.form.addControl(name, this.createControl(config));
        });

    }
  }

  createGroup() {
    const group = this.fb.group({});
    this.controls.forEach(control => group.addControl(control.name, this.createControl(control)));
    return group;
  }

  createControl(config: FieldConfig) {
    const { disabled, validation, value } = config;
    const validators = [];
    if (validation !== null && validation !== undefined) {
      validation.forEach(element => {
        // TODO: isto deve ser efectuado por reflexão - mas não funcionava correctamente e
        // avançou-se com a resolução dos casos necessários

        let fn = element.toString().replace('Validators.', '').toLowerCase();
        if (fn.indexOf('(') > 0) {
          fn = fn.substring(0, fn.indexOf('('));
        }
        const param = element.toString().substring(element.toString().indexOf('(') + 1, element.toString().indexOf(')'));

        switch (fn) {
          case 'required':
            validators.push(Validators.required);
            break;
          case 'requiredtrue':
            validators.push(Validators.requiredTrue);
            break;
          case 'email':
            validators.push(Validators.email);
            break;
          case 'min':
            validators.push(Validators.min(+param));
            break;
          case 'max':
            validators.push(Validators.max(+param));
            break;
          case 'minlength':
            validators.push(Validators.minLength(+param));
            break;
          case 'maxlength':
            validators.push(Validators.maxLength(+param));
            break;
          case 'pattern':
            validators.push(Validators.pattern(param));
            break;
          case 'nullValidator':
            validators.push(Validators.nullValidator);
            break;
        }

      });
    }
    return this.fb.control({ disabled, value }, validators);
  }

  handleSubmit(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.submit.emit(this.value);
  }

  setDisabled(name: string, disable: boolean) {
    if (this.form.controls[name]) {
      const method = disable ? 'disable' : 'enable';
      this.form.controls[name][method]();
      return;
    }

    this.config = this.config.map((item) => {
      if (item.name === name) {
        item.disabled = disable;
      }
      return item;
    });
  }

  setValue(name: string, value: any) {
    this.form.controls[name].setValue(value, { emitEvent: true });
  }

  setValues(values: any, clean = true) {

    if (clean) {
      this.form.reset();
    }

    Object.keys(values).map(key => {
      if (this.form.controls[key] !== undefined) {
        this.form.controls[key].setValue(values[key], { emitEvent: true });
      }
    });

  }

  clean() {
    this.form.markAsPristine();
    this.form.markAsUntouched();
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/dynamic-form/containers/dynamic-form/dynamic-form.component.ts